const Kernel = require('./services/Kernel');
window.Kernel = new Kernel();
window.Api = require('./components/appproxy/Api');
const Bindings  = require('./services/Bindings');
require("jquery-form");

window.mountApp = function () {
    let $body = $('body');

    // some bind
    new Bindings($body);

    window.Kernel.registerComponent('ShopModal', require('./components/ShopModal').default);
    window.Kernel.registerComponent('Header', require('./components/Header').default);
    window.Kernel.registerComponent('AttributeSelector', require('./components/AttributeSelector').default);
    window.Kernel.registerComponent('Searchbar', require('./components/Searchbar').default);
    window.Kernel.registerComponent('TriggerLinkOnClick', require('./components/TriggerLinkOnClick').default);
    window.Kernel.registerComponent('MegaMenu', require('./components/MegaMenu').default);
    window.Kernel.registerComponent('Account', require('./components/Account').default);
    window.Kernel.registerComponent('LangDropdown', require('./components/LangDropdown').default);
    window.Kernel.registerComponent('NetworkDropdown', require('./components/NetworkDropdown').default);
    window.Kernel.registerComponent('MainNav', require('./components/MainNav').default);
    window.Kernel.registerComponent('SplideJS', require('./components/SplideJS').default);

    // mount components
    window.Kernel.mountComponents($body);

    //Pace.start();

    $body.on("click","button[data-dismiss='modal']",function(e) {
       $(this).parents(".modal").first().removeClass("show").css('display','none');
    });
    $(document).ready(function() {
        var elements = document.getElementsByTagName("input");
        var feedbackMessage = $('.header-top').data("feedbackMessage");
        for (var i = 0; i < elements.length; i++) {
            elements[i].oninvalid = function(e) {
                e.target.setCustomValidity("");
                if (!e.target.validity.valid) {
                    e.target.setCustomValidity(feedbackMessage);
                    $(e.target).closest('.form-group').addClass('missing-field');
                }
            };
            elements[i].oninput = function(e) {
                e.target.setCustomValidity("");
                $(e.target).closest('.form-group').removeClass('missing-field');
            };
        }
    });

    function initRemoteModal(selector, remoteUrl, afterLoadedCallback, successCallback, errorCallback) {
        var $modal = $(selector);

        if (!$modal.length) {
            console.error('Modal not found !');
            return false;
        }

        $modal.on('hidden.bs.modal', function () {
            $('.modal-content', $modal).empty();
        });

        $('.modal-content', $modal).load(remoteUrl, function () {
            if (afterLoadedCallback != undefined) {
                afterLoadedCallback();
            }

            var $form = $modal.find('form');
            var $loader = $modal.find('.loading');

            var ajaxConfig = {
                beforeSubmit: function (arr, $form, option) {
                    if ($form.attr('data-confirm') !== undefined && $form.attr('data-confirm') !== 'confirmed') {
                        swal({
                            title: $form.attr("data-swal-title"),
                            text: $form.attr("data-swal-text"),
                            type: $form.attr("data-swal-type"),
                            showCancelButton: true,
                            confirmButtonText: 'Oui',
                            cancelButtonText: 'Non'
                        }).then(function (result) {
                            if (result.value) {
                                // En cas de confirmation, on submit le formulaire normalement.
                                // $form.removeAttr('data-confirm');
                                $form.attr('data-confirm', 'confirmed');
                                // var $form = $modal.find('form');
                                $form.submit();
                            }
                        });

                        return false;
                    }

                    $('form', $modal).addClass('hide');
                    $loader.removeClass('hide');
                },
                success: function (data) {

                    $modal.modal('hide');

                    if (successCallback != undefined) {
                        successCallback(data);
                    }
                },
                error: function (data, error, msg) {

                    if (errorCallback != undefined) {
                        errorCallback(data);
                    }

                    $loader.addClass('hide');
                    $('form', $modal).removeClass('hide');
                    var $error = $('<div/>').addClass('alert alert-block alert-danger fade in')
                        .html('' +
                            '<button data-dismiss="alert" class="close close-sm" type="button">' +
                            '   <i class="fas fa-times"></i>' +
                            '</button>' + HegydCore.getModalOutputData(data.responseJSON)
                        );
                    $form.prepend($error);
                }
            };

            $form.ajaxForm(ajaxConfig);
        });
        $modal.modal('show');
    }

};
$(document).ready(function () {
    mountApp();
});


// WEBPACK FOOTER //
// ./public/frontend/js/main.js